@import 'styles/mixins';
@import 'styles/variables';

.breadcrumb {
  align-items: center;
  display: flex;
  padding: 8px;
  border-bottom: 1px solid $grey-20;

  button {
    min-height: 36px;
  }

  height: 46px;

  &.v2 {
    padding: 6px 0px;
    border-bottom: 1px solid $grey-5;

    .folderButton {
      color: $grey-40;
      margin: 0 2px;
      padding: 2px 4px;
    }

    .noIconButton {
      padding: 2px 4px;
    }

    .divider {
      color: $grey-20;
      margin: 0 2px;
    }

    .currentFolder {
      color: $grey-50;
      padding: 2px 6px;
      margin-left: 2px;
    }
  }

  .workspaceButton {
    border: 1px solid transparent;
    cursor: pointer;
    padding: 2px;
    width: auto;
    height: 36px;

    &.disabled {
      cursor: initial;

      &:hover {
        border-color: transparent;
      }
    }

    &:hover {
      border: 1px solid $gray-10;
    }

    &.v2 {
      padding: 8px 8px;
    }
  }
}

.workspaceMenu {
  max-height: 200px;
  overflow-y: scroll;
  width: 240px;

  .workspaceRow {
    @include md-regular;

    align-items: center;
    color: $grey-50;
    display: flex;
    justify-content: space-between;
    padding: 8px;

    &:hover {
      background-color: $gray-5;
      cursor: pointer;
    }

    .workspaceName {
      align-items: center;
      display: flex;
      gap: 8px;

      .text {
        @include line-clamp();

        max-width: 180px;
      }
    }

    svg {
      path {
        fill: $almanac-black;
      }
    }
  }
}

.disabledBreadCrumb {
  .workspaceButton,
  .folderButton,
  .currentFolder {
    cursor: default;
  }
}
